<template>
  <div class="container" v-title data-title="邀请学生">
    <!---------------------------- banner ---------------------------->
    <van-image :src="invitation.bannerImg" fit="cover" width="100%" height="200"/>

    <!---------------------------- 按钮视图 ---------------------------->
    <div class="button-container flex main-space-evenly cross-center">
      <div class="button flex column cross-center" @click="onChoosePlatform('wx')">
        <img src="../../../assets/invitation/wechat.png" />
        <span>微信</span>
      </div>

      <div class="button flex column cross-center" @click="onChoosePlatform('wechat_line')">
        <img src="../../../assets/invitation/friend-line.png" />
        <span>朋友圈</span>
      </div>

      <div class="button flex column cross-center" @click="onChoosePlatform('qq')">
        <img src="../../../assets/invitation/qq.png" />
        <span>QQ</span>
      </div>

      <div class="button flex column cross-center" @click="onChoosePlatform('qzone')">
        <img src="../../../assets/invitation/qq-zone.png" />
        <span>QQ空间</span>
      </div>
    </div>

    <!---------------------------- 统计视图 ---------------------------->
    <div class="statistics-container">
      <!-- 统计头 -->
      <div class="statistics-container-header flex main-center cross-center">
        <img width="39" height="15" src="../../../assets/invitation/title-left.png" />
        <span>学生邀请统计</span>
        <img width="39" height="15" src="../../../assets/invitation/title-right.png" />
      </div>

      <!-- 邀请数/阅芽 -->
      <div class="statistics-container-content flex main-space-between cross-center">
        <div class="flex column main-center cross-center" style="height: 100%; flex: 1">
          <div class="title">{{invitation.invTeacherCount}}</div>
          <div class="subtitle">成功邀请</div>
        </div>
        <div style="height: 40%; width: 1px; background: #EEEEEEFF"></div>
        <div class="flex column main-center cross-center" style="height: 100%; flex: 1">
          <div class="title">{{invitation.point}}</div>
          <div class="subtitle">奖励阅芽</div>
        </div>
      </div>
    </div>

    <!---------------------------- 邀请记录 ---------------------------->
    <div class="record-container">
      <!-- header -->
      <div class="record-container-header flex main-space-between cross-center">
        <div>我的邀请记录</div>
        <div class="button flex main-center cross-center" @click="onLookRecordsEvent">
          <span>查看全部</span>
          <img src="../../../assets/invitation/arrow.png" style="margin-left: 4px">
        </div>
      </div>

      <!-- 提示视图 -->
      <div class="record-container-tip flex main-space-between cross-center">
        <span class="record-name">昵称</span>
        <span class="record-time">注册时间</span>
      </div>
      
      <!-- 列表 -->
      <div class="record-container-cell flex  cross-center" v-for="(item, index) in invitationRecords" :key="index">
        <span class="record-name">{{item.name}}</span>
        <span class="record-time">{{item.registerTime | dateAndMinTime}}</span>
      </div>

      <div v-if="!invitationRecords || invitationRecords.length === 0" class="record-container-cell flex main-center cross-center">
        <span style="font-size: 14px; color: #999999FF;">暂无记录</span>
      </div>

    </div>
  </div>
</template>

<script>
import * as InvitationsApi from "../../../api/Invitation.js";
import * as Utils from '../../../utils/utils'

export default {
  data(){
    return {
      invitation: {},
      invitationRecords: []
    }
  },
  created() {
    this.doReqeustStudentInvitations()
  },
  methods: {
    onLookRecordsEvent() {
      this.$router.push({name: 'InvitationStudentRecord'});
    },
    
    async doReqeustStudentInvitations() {
      this.invitation = await InvitationsApi.doReqeustStudentInvitations()
      this.invitation.invRecords.length > 5 ? this.invitation.invRecords.length = 5 : this.invitation.invRecords
      this.invitationRecords = this.invitation.invRecords
    },

    onChoosePlatform (platform) {
      if (Utils.isiOS()) {
        window.webkit.messageHandlers.JScallOCClick.postMessage(platform);
      } else {
        let url = window.location.href
        if(url.indexOf("platform") !== -1){
          let url1 = url.split("platform");
          url = url1 + 'platform=' + platform
        } else {
          url = url + '?platform=' + platform
        }
        window.location.href = url
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 父容器
.container {
  min-height: 100vh;
  height: 100%;
  width: 100vw;
  position: relative;

  // 按钮
  .button-container {
    position: absolute;
    top: 180px;
    left: 16px;
    right: 16px;
    height: 106px;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.04);
    opacity: 1;
    border: 1px solid #E3E3E3;
    border-radius: 10px;

    .button {
      img {
        width: 50px;
        height: 50px;
        margin-bottom: 10px;
      }
      span {
        height: 16px;
        font-size: 14px;
        font-weight: normal;
        color: #999999FF;
        line-height: 16px;
      }
    }
  }
  
  // 统计
  .statistics-container {
    position: absolute;
    top: 300px;
    left: 16px;
    right: 16px;
    height: 138px;
    background: linear-gradient(90deg, #44B499 0%, #3EE0A2 100%);
    opacity: 1;
    border-radius: 10px;
    
    .statistics-container-header {
      height: 50px;
      span {
        margin: 0 8px;
        height: 18px;
        font-size: 18px;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 18px;
      }
    }

    .statistics-container-content {
      width: auto;
      height: 80px;
      margin: 0 8px;
      background: #FFFFFF;
      border-radius: 12px;

      .title {
        height: 20px;
        font-size: 24px;
        font-family: D-DIN-Bold, D-DIN;
        font-weight: bold;
        color: #333333;
        line-height: 20px;
      }

      .subtitle{
        margin-top: 10px;
        height: 16px;
        font-size: 14px;
        font-weight: 300;
        color: #999999FF;
        line-height: 16px;
      }
    }
  }

  // 我的邀请记录
  .record-container {
    position: absolute;
    top: 450px;
    left: 16px;
    right: 16px;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.04);
    opacity: 1;
    border: 1px solid #E3E3E3;
    border-radius: 10px;
    padding-bottom: 16px;

    // 邀请记录
    .record-container-header {
      margin: 0 16px; 
      width: auto;
      height: 54px;
      font-size: 18px;
      color: #333333;
      line-height: 18px;

      .button {
        width: 91px;
        height: 26px;
        background: #ECFAF8;
        opacity: 1;
        border: 1px solid #21BEA1;
        border-radius: 26px;

        span {
          height: 16px;
          font-size: 14px;
          font-weight: normal;
          color: #21BEA1;
          line-height: 16px;
        }
      }
    }

    // 邀请记录提示框
    .record-container-tip {
      margin: 0 16px;
      height: 34px;
      background: #E6F8F4;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      padding: 0 32px;

      span {
        color: #21BEA1;
        height: 16px;
        font-size: 14px;
        font-weight: light;
        line-height: 16px;
      }
    }

    // 邀请记录内容
    .record-container-cell {
      margin: 0 16px;
      padding: 0 32px;
      height: 44px;
      background: #FFFFFF;
      box-shadow: inset 0px -1px 0px 0px #EEEEEE;
      opacity: 1;

      span {
        color: #333333FF;
        height: 16px;
        font-size: 14px;
        font-weight: light;
        line-height: 16px;
      }
    }

    .record-name {
      width: 50%;
      overflow: hidden; /*超出部分隐藏*/
      text-overflow: ellipsis; /*超出部分省略号表示*/
      white-space: nowrap; /*强制单行显示*/
    }
    
    .record-time {
      width: 50%;
      white-space: nowrap; /*强制单行显示*/
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/views/invitation/student/InvitationStudentInfo.vue